export default __webpack_public_path__ + "static/media/widget_watchbox_vpmndx1_sell.26998ec6.mp3";